var prodcat = prodcat || {};

prodcat.ui = prodcat.ui || {};
prodcat.data = prodcat.data || {};
var site = site || {};

(function ($) {
  $(document).on('product.init', '.js-product', function () {
    var $product = $(this);

    // restrict this only to v2 template, same event it's being called on old MPP's
    // and this js file will be available on QS lunch
    if ($product.hasClass('js-product-full-v2')) {
      var skuBaseId = $product.data('sku-base-id');
      // hasDramming:
      // 0 - Not a dramming product;
      // 1 - dramming prodct & foucs on second select box
      // noshade - dramming product and don't trigger product_&shade_select_,full_shades,full_shades_flyout&_v1.js on init only.
      var hasDramming = false;

      if ($product.hasClass('js-product-dramming')) {
        hasDramming = 'noshade';
      }
      $product.trigger('product.skuSelect', [skuBaseId, hasDramming]);
    }
  });

  $(document).on('product.skuSelect', '.js-product', function (e, skuBaseId) {
    var $product = $(this);
    var skuData = prodcat.data.getSku(skuBaseId);

    if (!_.isNull(skuData)) {
      var ingredients = skuData.ILN_LISTING;
      var $ilnSection = $product.find('.js-product-full__data-section--iln');
      var $ilnData = $ilnSection.find('.js-product-full-iln-listing');

      if ($ilnSection.length >= 1 && ingredients) {
        $ilnSection.show(); // section wrapper restore
        if ($ilnData.length) {
          $ilnData.html(ingredients);
        }
      } else {
        $ilnSection.hide(); // section wrapper hide if sku is missing ingredients
      }
    }
  });

  $(document).on('product:quickshop:available', function () {
    Drupal.behaviors.productFullV2.attached = false;
    Drupal.behaviors.productFullV2.attach($(this));
  });

  Drupal.behaviors.productFullV2 = {
    attach: function (context) {
      if (this.attached) {
        return;
      }
      this.attached = true;
      var $template = $('.js-product-full-v2', context);
      var $expanderSections = $('.product-full__data-section', $template);

      // section expanders
      if ($expanderSections.length) {
        $expanderSections.each(function () {
          var $this = $(this);
          var $trigger = $this.find('.product-full__data-heading');
          var callback = function (event, el) {
            var $this = el ? $(el) : $(this);
            var $content = $this.next('.product-full__data-content');
            // Cast the expanded state as a boolean
            var expanded = $this.attr('aria-expanded') === 'false' ? false : true;

            // Switch the states of aria-expanded and aria-hidden
            $this.attr('aria-expanded', !expanded);
            $content.attr('aria-hidden', expanded);
          };

          // click handler
          $trigger.on('click', callback).on('keydown', function (e) {
            var key = site.getKeycode(e);

            if (key === 13) { // Enter
              e.preventDefault();
              callback(e, this);
            }
          });
        });
      }
    },
    attached: false
  };
})(jQuery);
